
import React from 'react';
import { Badge } from '@/components/ui/badge';

export function CertificateLegend() {
  return (
    <div className="flex justify-between items-center text-sm text-muted-foreground">
      <div>
        Showing up to 100 results. Use the search or filters to narrow down the results.
      </div>
      <div className="flex gap-2">
        <div className="flex items-center gap-1">
          <Badge variant="success" className="h-2 w-2 p-0 rounded-full" /> Reported
        </div>
        <div className="flex items-center gap-1">
          <Badge variant="destructive" className="h-2 w-2 p-0 rounded-full" /> Not Reported
        </div>
      </div>
    </div>
  );
}
